import styled from 'styled-components';
import React from 'react';
import _ from 'lodash';
import * as api from '~/myApi'
import * as enums from '~/const/enums'
import createTotalRatios, { Retios } from '~/utils/targetRetio'
import Table from '~/component/common/Table'
import { ColumnsType } from 'rc-table/lib/interface'

const ProgressTotalCollected = styled.p`
  text-align: center;
  margin: 0 8px;
  padding: 8px 0;
  font-size: 13px;
  font-weight: bold;
  background-color: rgb(255, 255, 255);
`

interface TargetRetioTableProps {
  value?: api.TypesTargetRatio;
  targetCollectionNum?: number;
  progress?: api.TypesProgress[];
  hideContactRatio?: boolean;
}

export const TargetRetioTable: React.FC<TargetRetioTableProps> = (props) => {

  const ratios = createTotalRatios(props.value).map((v, i) => Object.assign({}, v, { id: i }))
  const total: number = _.chain(ratios).map(v => _.chain(v).toPairs().map(([key, v]) => v.num).value()).flatten().reduce(_.add).value()

  if (ratios.length === 0) return <></>

  const progressTotalCollectedNum = _.size(props.progress) && _(_.map(props.progress, (p) => p.collectedNum || 0)).reduce(_.add)

  const columns: ColumnsType<Retios> = [
    props.hideContactRatio ? {
      key: 'contact',
      title: '接触・非接触',
      render: (data, record) => record.contact?.key ? enums.AD_CONTACT_STATUS_RATIO.find((v) => v.key === record.contact?.key)!.label : '-',
    } : {},
    {
      key: 'cluster', 
      title: 'クラスタ',
      render: (data, record) => record.cluster?.key ? enums.CLUSTER_RATIO.find((v) => v.key === record.cluster?.key)!.label : '-'
    },
    {
      key: 'device', 
      title: 'デバイス',
      render: (data, record) => record.device?.key ? enums.DEVICE_RATIO.find((v) => v.key === record.device?.key)!.label : '-'
    },
    {
      key: 'carrer', 
      title: 'キャリア',
      render: (data, record) => record.carrer?.key ? enums.CARRER_RATIO.find((v) => v.key === record.carrer?.key)!.label : '-'
    },
    {
      key: 'os', 
      title: 'OS',
      render: (data, record) => record.os?.key ? enums.OS_RATIO.find((v) => v.key === record.os?.key)!.label : '-'
    },
    {
      key: 'meyasu',
      title: progressTotalCollectedNum ? '回答進捗' : '目安回答数',
      render: (data, record) => {
        const rowTotal = Math.ceil((props.targetCollectionNum || 0) / (total / _.chain(record).toPairs().map(([_, v]) => v!.num).reduce(_.add).value()))

        const target = props.progress?.find((p) => (
          (!record.contact?.key || !!record.contact?.key && enums.AD_CONTACT_STATUS_RATIO.find((v) => v.key === record.contact?.key)!.enumKey === p.target?.adContactStatus!) &&
          (!record.cluster?.key || !!record.cluster?.key && enums.CLUSTER_RATIO.find((v) => v.key === record.cluster?.key)!.enumKey === p.target?.targetCluster!) &&
          (!record.device?.key || !!record.device?.key && enums.DEVICE_RATIO.find((v) => v.key === record.device?.key)!.enumKey === p.target?.targetDevice!) &&
          (!record.carrer?.key || !!record.carrer?.key && enums.CARRER_RATIO.find((v) => v.key === record.carrer?.key)!.enumKey === p.target?.targetCarrer!) &&
          (!record.os?.key || !!record.os?.key && enums.OS_RATIO.find((v) => v.key === record.os?.key)!.enumKey === p.target?.targetOs!)
        ))

        if (typeof target?.collectedNum === 'number') {
          return `${target?.collectedNum}回答 / ${rowTotal}目標(${Math.ceil(target?.collectedNum / rowTotal * 100)}%)`
        } else {
          return rowTotal
        }
      },
    }
  ]

  return (<>
    {progressTotalCollectedNum ? (
      <ProgressTotalCollected>{progressTotalCollectedNum} 回答 / {props.targetCollectionNum} 目標（{Math.ceil(progressTotalCollectedNum / (props.targetCollectionNum || 0) * 100)}%）</ProgressTotalCollected>
    ) : <></>}

    <Table {...{
      rowKey: 'id',
      columns: columns.filter((v) => v.key),
      scroll: { y: 300 },
      data: ratios
    }} />
  </>);
};

export default TargetRetioTable